import React from "react";
import Img from "../../../assets/Group 194.svg";
import "./aboutus.scss";
import { Zoom } from "react-awesome-reveal";
const AboutUs = () => {
  return (
    <div className="about-us">
      <div className="container"></div>
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="about-us-image">
              <img src={Img} alt="" />
            </div>
          </div>
          <div className="col-lg-8 d-flex align-items-center">
            <div className="about-us-content">
              <div className="vision" id="image-container">
                <div className="row row-cols-2">
                  <Zoom>
                  <h3>About Us</h3>
                  </Zoom>
                </div>
                <span>
                  Established in 2002, Varrenyam Consultants Pvt. Ltd. proudly
                  operates in New Delhi and Mumbai.
                  <br />
                  <span>
                    Our track record speaks volumes as we consistently deliver
                    tangible results and offer committed, implementable
                    solutions to our diverse clientele.
                  </span>
                </span>
                <br />
                <span>
                  With a focus on cost-effective and timely financial support,
                  we boast strong affiliations with top legal firms, TAV
                  Consultants, Valuers, IP Entities, Fund Houses, O&amp;M
                  service providers.....
                </span>
              </div>
              <br />
              <div className="who-are-we" id="image-container">
                <div className="row row-cols-2">
                <Zoom>
                  <h3>Vision</h3>
                </Zoom>
                </div>
                <span>
                  To emerge as the premier ‘One Stop Financial Solution
                  Provider' specializing in the resolution of distressed assets.
                </span>
                <br />
                <span className="mb-5">
                  Offering comprehensive expertise to navigate and optimize
                  financial landscapes.
                </span>
              </div>
              <a href="/about">
                <p className="my-3">Learn More..</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
